// 도메인 → 역할 키 매핑. 분기의 단일 진실 공급원
export type SiteKey = 'participant' | 'hq' | 'partner' | 'manager'

const SITE_MAP: Record<string, SiteKey> = {
  // 운영
  'sadari2026.com': 'participant',
  'hq.sadari2026.com': 'hq',
  'partner.sadari2026.com': 'partner',
  'manager.sadari2026.com': 'manager',
  // 스테이지 (동일 빌드 공유)
  'stage.sadari2026.com': 'participant',
  'stage-hq.sadari2026.com': 'hq',
  'stage-partner.sadari2026.com': 'partner',
  'stage-manager.sadari2026.com': 'manager',
}

export const ALL_SITES: SiteKey[] = ['participant', 'hq', 'partner', 'manager']

// 호스트명으로 역할 결정. 미등록 호스트는 participant로 폴백한다
export function siteForHost(hostname: string): SiteKey {
  return SITE_MAP[hostname] ?? 'participant'
}

// 부트스트랩에서 한 번만 호출. dev는 VITE_SITE(유효값일 때만), 그 외엔 hostname으로 분기
export function resolveSite(): SiteKey {
  if (import.meta.env.DEV && import.meta.env.VITE_SITE) {
    const injected = import.meta.env.VITE_SITE
    if (ALL_SITES.includes(injected as SiteKey)) return injected as SiteKey
  }
  return siteForHost(window.location.hostname)
}
